<template>
    <div class="form-dynamic-wrapper mb-2">
        <b-row class="pr-5">
            <b-col md="4">
                <b-form-group label="Tahun / Generasi">
                    <b-input v-model="hargaTahun.selectedTahun" maxlength="60" required />
                </b-form-group>
            </b-col>
            <b-col md="4" v-if="!isKendaraan">
                <b-form-group label="Harga">
                    <b-input-group prepend="Rp.">
                        <b-form-input v-model="hargaTahun.harga" name="harga" required></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="4" v-if="isKendaraan">
                <b-form-group label="Harga Kendaraan">
                    <b-input-group prepend="Rp.">
                        <b-form-input v-model="hargaTahun.hargaKendaraan" name="hargaKendaraan" required></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="4" v-if="isKendaraan">
                <b-form-group label="Harga BPKB">
                    <b-input-group prepend="Rp.">
                        <b-form-input v-model="hargaTahun.hargaBpkb" name="hargaBpkb" required></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <!-- <b-col cols="10" md="2" >
                <label for="file">File PDF</label>

                <FormulateForm v-model="pdf">
                    
                    <FormulateInput v-if=" hargaTahun.url != null && hargaTahun.url.length != 0"
                    id="urlPDF"
                    name="urlPDF"
                    ref="urlPDF"
                    type="file"
                    :value="hargaTahun.url"
                    help="Format Harus PDF"
                    accept=".pdf"
                    validation="mime:application/pdf"
                    multiple
                    />
                    <FormulateInput v-else
                    type="file"
                    name="file"
                    help="Format Harus PDF"
                    validation="mime:application/pdf"
                    accept=".pdf"
                    fileRemove
                    multiple
                    />
                </FormulateForm>
            </b-col>
            <b-col cols="2" class="mt-4">
                <div v-if="pdf != null "> 
                    <div v-if="pdf.urlPDF != undefined || pdf.urlPDF != null ">
                        <div v-for="file of pdf.urlPDF.files">            
                            <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF( file.file.size != null ?file.file : $baseFilePath + file.file.previewData )">View</b-button>                
                        </div>
                    </div> 

                    <div v-if="pdf.file != undefined || pdf.file != null ">
                        <div v-for="file of pdf.file.files">            
                            <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF( file.file.size != null ?file.file : $baseFilePath + file.file.previewData )">View</b-button>                
                        </div>
                    </div> 
                </div>
                
            </b-col>     -->
        </b-row>
            <div class="form-dynamic-deleteWrapper">
            <b-button variant="dynamicDeleteBtn" name="deleteHargaTahun"  :hidden="hargaTahun.id != 0" @click="$emit('remove', hargaTahun.index)"><i class="fa fa-times"></i></b-button>
            <b-button variant="dynamicDeleteBtn mt-2"  @click="$emit('nonAktif', hargaTahun.index)" :hidden="hargaTahun.id == 0"><i class="fa fa-minus"></i></b-button>
        </div>

        
    </div>
</template>

<script>
export default {
    name: 'harga-tahun',
    props: {
        hargaTahun: { type: Object, required: true },
        length: { type: Number, required: true },
        isKendaraan: { type: Boolean, required: true },
        idHargaTahun:{ type : Number },
        // filePDF : { type : Array},
    },
    data(){
        return{
            // pdf: null
        }
    },
    methods: {

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })

        },
    },
    watch: {
        "hargaTahun.harga": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.hargaTahun.harga = result);
        },
        "hargaTahun.hargaKendaraan": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.hargaTahun.hargaKendaraan = result);
        },
        "hargaTahun.hargaBpkb": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.hargaTahun.hargaBpkb = result);
        },
    }
}
</script>